import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { services } from '../mockData';
import servicePageMap from './services/servicePageMap';

const ServiceDetail = () => {
  const { slug } = useParams();

  const service = services.find(s => s.slug === slug);
  const PageComponent = servicePageMap[slug];

  if (!service || !PageComponent) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-6">Service Not Found</h1>
          <Button asChild>
            <Link to="/services">View All Services</Link>
          </Button>
        </div>
      </div>
    );
  }

  // ✅ Dynamic page render with service data
  return <PageComponent service={service} />;
};

export default ServiceDetail;
